Apt.fn.make('catalog', {
	/**
	 * Initialize module
	 */
	init: function() {
		var category = $.get('category'),
			query = {
				limit: 36
			};

		if (category) {
			query.params = {
				category: category
			};
		}

		this.filters = Apt.fn.filters()
			.init('catalog', {
				source: 'api/v1/catalog',
				view: 'catalog.results',
				query: query,
				fn: function() {
					Apt.wishlists.highlight();
				}
			});

		Apt.wishlists.bind('catalog');
	},

	/**
	 * Unload module
	 */
	unload: function() {
		$.events.reset('catalog');
		this.filters.$destroy();
	}
});